import { render, staticRenderFns } from "./ServizioDialog.vue?vue&type=template&id=ba1f4682"
import script from "./ServizioDialog.vue?vue&type=script&lang=js"
export * from "./ServizioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports